<div *ngIf="!onlineOffline || socketDisconneted" class="offline">
    <span>
        <mat-icon class="offline--icon">wifi_off</mat-icon>
        {{ socketDisconneted ? "A função de atualização automática está fora do ar." : "Você esta sem conexão com a
        internet no momento." }}
    </span>
</div>

<div *ngIf="!mainClient" class="wating-password">
    AGUARDANDO UMA SENHA SER CHAMADA...
</div>

<div *ngIf="mainClient" class="content" [ngClass]="{'content-padding-top': !onlineOffline || socketDisconneted}">

    <div class="main-call">
        <div class="main-call__password">
            <div class="password_label">SENHA</div>
            <div class="main-call__ticket">{{mainClient.ticket}}</div>
        </div>
        <div class="main-call__location">
            {{ mainClient.nameSector + " - " + mainClient.nameRoom}}
        </div>
        <div class="main-call__patient">
            {{mainClient.namePacient}}
        </div>
    </div>

    <div class="history-main">
        <div class="title-history-content">
            <span class="title-txt">ÚLTIMOS CHAMADOS:</span>
        </div>

        <div class="history-list-wrapper">
            <ng-container *ngFor="let client of historicalList; let i=index">
                <div *ngIf="i < 3" class="history-call">
                    <div class="history-content">
                        <div class="client-info">
                            <span class="text-info-color label-senha">Senha</span>
                            <span class="bold text-info-color font-size-1-8 ticket-senha">
                                {{client.ticket}}
                            </span>
                            <span *ngIf="client.namePacient" class="text-info-color font-size-1-8 separator">|</span>
                            <span *ngIf="client.namePacient" class="text-info-color patient-name-history">
                                {{client.namePacient}}
                            </span>
                        </div>
                        <span class="sector-info">
                            {{ client?.nameSector + ' ' + client?.nameRoom}}
                        </span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<footer class="footer-bar">
    <div class="footer-section left">
        <img *ngIf="this.sanitezedLogo" class="brand" [src]="this.sanitezedLogo">
        <img class="brand" src="assets/images/logo-branco.png">
    </div>
    <div class="footer-section center">
        <span *ngIf="showAverageWaitingTime" class="personalized-waiting-hours">
            MÉDIA DE ESPERA - TRIAGEM: {{lastHourWaitingTimeAverage}}
            <span class="text-last-hour">(última hora)</span>
        </span>
    </div>
    <div class="footer-section right">
        <span class="date-time"><mat-icon>calendar_today</mat-icon>{{date}}</span>
        <span class="date-time"><mat-icon>schedule</mat-icon>{{time}}</span>
    </div>
</footer>